import {Category, Question} from "src/interfaces";

export const scanKnowledgeBase = (
  message: string,
  questions: Question[],
  categories: Category[],
  languageCode: string,
): {questions: Question[]; categories: Category[]} => {
  const processedMessage = message.toLowerCase().trim();
  const messageWords = processedMessage.split(" ").filter(Boolean);
  const questionScores = new Map<Question, number>();
  const categoryScores = new Map<Category, number>();

  questions?.forEach((question) => {
    const questionLang = question.langs[languageCode];
    if (questionLang) {
      const score = calculateMatchScore(
        processedMessage,
        messageWords,
        questionLang.question.toLowerCase(),
        questionLang.answer.toLowerCase(),
      );
      if (score > 0) {
        questionScores.set(question, score);
      }
    }
  });

  categories?.forEach((category) => {
    const categoryLang = category.langs[languageCode];
    if (categoryLang) {
      const score = calculateMatchScore(
        processedMessage,
        messageWords,
        categoryLang.name.toLowerCase(),
        categoryLang.description.toLowerCase(),
      );
      if (score > 0) {
        categoryScores.set(category, score);
      }
    }
  });

  return {
    questions: Array.from(questionScores.entries())
      .sort((a, b) => b[1] - a[1])
      .map(([question]) => question),
    categories: Array.from(categoryScores.entries())
      .sort((a, b) => b[1] - a[1])
      .map(([category]) => category),
  };
};

function calculateMatchScore(searchPhrase: string, searchWords: string[], ...textsToSearch: string[]): number {
  let score = 0;

  for (const text of textsToSearch) {
    if (text.includes(searchPhrase)) {
      score += searchWords.length * 2;
    }
  }

  for (const text of textsToSearch) {
    searchWords.forEach((word) => {
      if (text.includes(word)) {
        score += 1;
      }
    });
  }

  return score;
}
